<template>
  <div>
    <TopAside />
    <div :style="{height:height+'px'}" class="main">
      <div class="teachers">
        <div class="toux">
          <i class="el-icon-user-solid"></i>
        </div>
        <p>张小龙</p>
        <p>浦东新区曹路小学</p>
        <p>177xxxx4293</p>
      </div>
      <div class="mobileMenu">
        <el-row>
          <el-col :span="8">
            <router-link :to="{name:'teachingManage'}">
              教学管理
            </router-link>
          </el-col>
          <el-col :span="8">
            <router-link :to="{name:'studentManage'}">
              学员管理
            </router-link>
          </el-col>
          <el-col :span="8">
            <router-link :to="{name:'studentManage'}">
              班级管理
            </router-link>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <router-link :to="{name:'studentManage'}">
              订单管理
            </router-link>
          </el-col>
          <el-col :span="8">
            <router-link :to="{name:'studentManage'}">
              作品管理
            </router-link>
          </el-col>
          <el-col :span="8">
            <router-link :to="{name:'studentManage'}">
              学情管理
            </router-link>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
import TopAside from './top-aside';
export default {
  data () {
    return {
      height: 0
    };
  },
  components: {
    TopAside
  },
  mounted () {
    let mainH = document.documentElement.clientHeight;
    this.height = mainH - 50;
  }
}
</script>
<style scoped lang="scss">
.main {
  background: #fff;
}
.teachers {
  width: 100%;
  height: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .toux {
    text-align: center;
    i {
      font-size: 40px;
    }
  }
  p {
    text-align: center;
    line-height: 30px;
  }
}
.MenuList {
  width: 200px;
  height: 200px;
  border: 1px solid #ccc;
}
.mobileMenu {
  padding: 20px;
  .el-row {
    height: 100px;
    .el-col {
      border: 1px solid #ccc;
      height: 100%;
      text-align: center;
      line-height: 100px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/layout/component/MobileHome.vue